<script>
import Layout from "@layouts/form";
import Projeto from "@forms/Projeto";

export default {
  page: {
    title: "Detalhes | Projeto"
  },
  components: { Layout, Projeto },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Projeto",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Projeto",
          href: "/Projeto"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <Projeto :editable="editable"></Projeto>
    </div>
  </Layout>
</template>
